import React from "react";
import { FONTS } from "../../../lib/marketApi";
import { Card, ImageUpload, inputCls, Labeled } from "./ui";

const COLOR_FIELDS = [
  ["primary", "Color principal"],
  ["accent", "Color de ofertas"],
  ["bg", "Fondo"],
  ["surface", "Tarjetas"],
  ["text", "Texto"],
];
const PRESETS = [
  { name: "Azul", primary: "#2563EB", accent: "#F59E0B", bg: "#F5F7FB", surface: "#FFFFFF", text: "#0F172A" },
  { name: "Noche", primary: "#22D3EE", accent: "#F472B6", bg: "#0B1120", surface: "#111827", text: "#F1F5F9" },
  { name: "Esmeralda", primary: "#059669", accent: "#F97316", bg: "#F3FAF6", surface: "#FFFFFF", text: "#052E1C" },
  { name: "Lujo", primary: "#B08D57", accent: "#7F1D1D", bg: "#FAF7F2", surface: "#FFFFFF", text: "#1C1917" },
  { name: "Coral", primary: "#F43F5E", accent: "#8B5CF6", bg: "#FFF7F7", surface: "#FFFFFF", text: "#1F1023" },
];
const TEXT_FIELDS = [
  ["announcement", "Barra de anuncio superior"],
  ["hero_title", "Título principal"],
  ["hero_subtitle", "Subtítulo"],
  ["hero_cta", "Texto del botón principal"],
  ["products_title", "Título de productos"],
  ["about_title", "Título 'Sobre nosotros'"],
  ["about", "Texto 'Sobre nosotros'", true],
  ["footer", "Texto del pie de página"],
];

export const DesignTab = ({ draft, setDraft }) => {
  const theme = draft.theme || {};
  const texts = draft.texts || {};
  const setTheme = (k, v) => setDraft((d) => ({ ...d, theme: { ...d.theme, [k]: v } }));
  const setText = (k, v) => setDraft((d) => ({ ...d, texts: { ...d.texts, [k]: v } }));
  return (
    <div className="space-y-4">
      <Card title="Marca">
        <Labeled label="Nombre de la tienda"><input className={inputCls} value={draft.name} onChange={(e) => setDraft((d) => ({ ...d, name: e.target.value }))} data-testid="design-name-input" /></Labeled>
        <Labeled label="Logo"><ImageUpload value={theme.logo} onChange={(v) => setTheme("logo", v)} label="Subir logo" testid="design-logo-upload" /></Labeled>
        <Labeled label="Imagen de portada"><ImageUpload value={theme.banner} onChange={(v) => setTheme("banner", v)} label="Subir portada" testid="design-banner-upload" /></Labeled>
      </Card>
      <Card title="Colores">
        <div className="flex flex-wrap gap-2">
          {PRESETS.map((p) => (
            <button key={p.name} onClick={() => setDraft((d) => ({ ...d, theme: { ...d.theme, ...p, name: undefined } }))} className="flex items-center gap-2 rounded-full border border-slate-200 px-3 py-1.5 text-xs font-medium" data-testid={`design-preset-${p.name}`}>
              <span className="h-4 w-4 rounded-full" style={{ background: `linear-gradient(135deg, ${p.primary} 50%, ${p.bg} 50%)` }} /> {p.name}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {COLOR_FIELDS.map(([k, l]) => (
            <label key={k} className="flex items-center gap-2 rounded-xl border border-slate-200 p-2">
              <input type="color" value={theme[k] || "#000000"} onChange={(e) => setTheme(k, e.target.value)} className="h-8 w-8 cursor-pointer rounded border-0 bg-transparent" data-testid={`design-color-${k}`} />
              <span className="text-xs text-slate-600">{l}</span>
            </label>
          ))}
        </div>
      </Card>
      <Card title="Estilo">
        <Labeled label="Tipografía">
          <select className={inputCls} value={theme.font} onChange={(e) => setTheme("font", e.target.value)} data-testid="design-font-select">
            {FONTS.map((f) => <option key={f} value={f}>{f}</option>)}
          </select>
        </Labeled>
        <Labeled label={`Redondeo de esquinas: ${theme.radius ?? 18}px`}>
          <input type="range" min="0" max="32" value={theme.radius ?? 18} onChange={(e) => setTheme("radius", Number(e.target.value))} className="w-full" data-testid="design-radius-range" />
        </Labeled>
      </Card>
      <Card title="Textos">
        {TEXT_FIELDS.map(([k, l, area]) => (
          <Labeled key={k} label={l}>
            {area ? (
              <textarea rows={3} className={inputCls} value={texts[k] || ""} onChange={(e) => setText(k, e.target.value)} data-testid={`design-text-${k}`} />
            ) : (
              <input className={inputCls} value={texts[k] || ""} onChange={(e) => setText(k, e.target.value)} data-testid={`design-text-${k}`} />
            )}
          </Labeled>
        ))}
      </Card>
    </div>
  );
};
